/**
 * What a page pop-out shows for a page the user may not open (or a URL that
 * names no page). A pop-out has no sidebar to have hidden the page, so it
 * checks access itself and says so plainly instead of rendering the page.
 */
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';

export function PopoutNoAccess() {
  const { t } = useTranslation();
  return (
    <div role="alert" className="mx-auto max-w-xl space-y-3 p-10 text-center" data-testid="popout-no-access">
      <Lock className="mx-auto h-8 w-8 text-ink-400" aria-hidden="true" />
      <h2 className="font-display text-lg font-semibold text-ink">
        {t('appPopout.no_access_title', "You don't have access to this page")}
      </h2>
      <p className="text-sm text-ink-500">
        {t(
          'appPopout.no_access_body',
          "This page isn't available to your role in this organization, or the link doesn't point to a page. Ask an administrator if you think you should have access.",
        )}
      </p>
    </div>
  );
}

export default PopoutNoAccess;
